export default __webpack_public_path__ + "static/venetian-mask-a77615d11e2921d280fc404eac115e08.jpg";